import CategoryMeasurementSection from '@c/CategoryMeasurementSection';
import { CategoryDocument } from 'models/category';

const DynamicMeasurementSection = ({
  selectedCat,
  onSelect,
}: {
  selectedCat?: CategoryDocument;
  onSelect?: (measurements: {
    weight: { value: number; unit: 'ounce' };
    dimensions: {
      length: number;
      unit: 'inch';
      width: number;
      height: number;
    };
  }) => void;
}) => {
  if (!selectedCat) return null;
  return (
    <CategoryMeasurementSection
      category={selectedCat.name}
      dimensions={{
        length: selectedCat.package?.length ?? 0,
        width: selectedCat.package?.width ?? 0,
        height: selectedCat.package?.height ?? 0,
        unit: 'inch',
      }}
      weight={{
        value: selectedCat.package?.weight
          ? selectedCat.package.weight * 16
          : 0,
        unit: 'ounce',
      }}
      onSelect={(e) => onSelect?.(e)}
    ></CategoryMeasurementSection>
  );
};

export default DynamicMeasurementSection;
